import React from 'react';
import { Theme } from '../types/theme';
import ReviewForm from './ReviewForm';

interface ReviewOverlayProps {
    isOpen: boolean;
    onSubmit: (feedback: { categories: string[]; comment: string }) => void;
    onCancel: () => void;
    theme: Theme;
}

const ReviewOverlay: React.FC<ReviewOverlayProps> = ({ isOpen, onSubmit, onCancel, theme }) => {
    if (!isOpen) return null;

    return (
        <div className="absolute inset-0 z-50 flex items-start justify-center p-4 sm:p-6 overflow-y-auto">
            {/* Backdrop */}
            <div
                className="absolute inset-0 bg-black/30 backdrop-blur-[4px] transition-opacity"
                onClick={onCancel}
            />

            {/* Wrapper to constrain width and ensure centering */}
            <div className="relative w-full max-w-sm z-10 animate-in fade-in zoom-in-95 duration-300 my-auto">
                <ReviewForm
                    onSubmit={onSubmit}
                    onCancel={onCancel}
                    theme={theme}
                />
            </div>
        </div>
    );
};

export default ReviewOverlay;
